// extracted by mini-css-extract-plugin
export default {"header":"header_PGWyR","logo":"logo_LDgDN","right":"right_BXBxM"};